import { BallPointPenJsEnv } from "./ballpoint_pen_js_env";

export class BallPointPen {
  constructor(private model: BallPointPenJsEnv) {
    this.model = { ...model };
  }

  getModel(): BallPointPenJsEnv {
    return {
      ...this.model
    };
  }

  updateSeries(ballPointPenSeries: string[], selectedMaker: string) {
    this.model.selectedMaker = selectedMaker;

    this.model.ballPointPenSeries = ballPointPenSeries;
    this.model.selectedSeries = '';

    this.model.ballPointPenSizes = [];
    this.model.selectedSize = '';
  }

  updateSizes(ballPointPenSizes: string[], selectedSeries: string) {
    this.model.selectedSeries = selectedSeries;

    this.model.ballPointPenSizes = ballPointPenSizes;
    this.model.selectedSize = '';
  }

  updateSelectedSize(selectedSize: string) {
    this.model.selectedSize = selectedSize;
  }

  updateModel(ballPointPenSeries: string[], ballPointPenSizes: string[], selectedMaker: string, selectedSeries: string, selectedSize: string) {
    this.model.ballPointPenSeries = ballPointPenSeries;
    this.model.ballPointPenSizes = ballPointPenSizes;
    this.model.selectedMaker = selectedMaker;
    this.model.selectedSeries = selectedSeries;
    if (selectedSize === null) {
      this.model.selectedSize = '';
    } else {
      this.model.selectedSize = selectedSize;
    }
  }

  setSelectedBallpointPenMaker(selectedBallpointPen: string) {
    this.model.selectedMaker = selectedBallpointPen;
  }
}
